import axios from '../axios';
import { poolHelper } from '../common/pool-pormise-helper';
import { numeralFormat } from '../common/numeralFormat';
import lodash from 'lodash';

export const ACTIONS = {
    GET_CATEGORY_TOPICS_SUCCESS: 'GET_CATEGORY_TOPICS_SUCCESS',
    SET_TITLE_TOPIC: 'SET_TITLE_TOPIC',
};

const getTopStatuses = () => {
    return async () => {
        const { data } = await axios.get('api/masters/topic_statuses');
        return data;
    };
};

const getTopicTypes = (topicId) => {
    return async () => {
        const { data } = await axios.get(`api/topics/${topicId}/sources`);
        return data.map((item, idx) => {
            item.id = idx + 1;
            return item;
        });
    };
};


const getTopicCell = (topicId, cellId) => {
    return async () => {
        const { data } = await axios.get(`api/topics/${topicId}/cells/${cellId}`);
        return data;
    };
};

const addTopicCell = (params) => {
    return async () => {
        const { topicId, order = 1, topicsSourceId } = params;
        const { data } = await axios.post(`api/topics/${topicId}/cells`, {
            order,
            topics_source_id: topicsSourceId,
        });
        return data;
    };
};

const removeTopicCell = (params) => {
    return async () => {
        const { topicId, cellId } = params;
        const { data } = await axios.delete(`api/topics/${topicId}/cells/${cellId}`);
        return data;
    };
};

const updateTopicCell = (params) => {
    return async () => {
        const { topicId, cellId, memo, title, graphs, filters, columns } = params;
        const body = {};
        if (memo !== undefined) {
            body.memo = memo;
        }
        if (title !== undefined) {
            body.title = title;
        }
        if (filters) {
            body.filters = filters;
        }
        if (columns) {
            body.columns = columns;
        }
        if (graphs) {
            body.graphs = graphs;
        }
        const { data } = await axios.put(`api/topics/${topicId}/cells/${cellId}`, body);
        return data;
    };
};

const deleteTopic = (topicId) => {
    return async () => {
        const { data } = await axios.delete(`api/topics/${topicId}`);
        return data;
    };
};
const copyTopic = (topicId) => {
    return async () => {
        const { data } = await axios.post(`api/topics/${topicId}/copy`, {
            workspace_id: -1,
        });
        return data;
    };
};

const updateTopic = (params) => {
    return async () => {
        const { topicId, title, topicStatusId } = params;
        const { data } = await axios.put(`api/topics/${topicId}`, {
            title,
            topic_status_id: topicStatusId,
        });
        return data;
    };
};

const getTopic = (topicId) => {
    return async () => {
        const { data } = await axios.get(`api/topics/${topicId}`);
        return data;
    };
};

const createTopic = (params) => {
    return async () => {
        const { gameId, teamId, playerId, useDefault } = params;
        const { data } = await axios.post(`api/topics`, {
            game_id: gameId,
            team_id: teamId,
            player_id: playerId,
            use_default: useDefault,
        });
        return data;
    };
};

const getConfigCells = (params) => {
    return async () => {
        const { cellId, topicId } = params;
        const { data } = await axios.get(`api/topics/${topicId}/cells/${cellId}/config`);
        return data;
    };
};

const getCategoryTopics = (type, id) => {
    return async (dispatch) => {
        const { data } = await axios.get(`api/topics/categories/${type}/id/${id}`);
        dispatch({ type: ACTIONS.GET_CATEGORY_TOPICS_SUCCESS, list: data, typeTopic: type });
        return data;
    };
};

const getCellDetail = async (topicId, ids) => {
    let cellList = [];
    try {
        await poolHelper({
            data: ids,
            maxParallelRequests: 1,
            apiPath: (id) => {
                return `api/topics/${topicId}/cells/${id}`
            },
            callbackSuccess: (response) => {
                const cellDetail = response.data.result.data;
                cellList.push(cellDetail);
            },
            callbackError: () => { },
        });
        return cellList;
    } catch (error) {
        return cellList;
    }
};

const getDetailTopic = (topicId) => {
    return async () => {
        const { data } = await axios.get(`api/topics/${topicId}`);
        const cellIds = data.cells.map(cell => cell.id);
        const cellResponse = await getCellDetail(topicId, cellIds);
        const topic = data.topic;
        const updatedDateText = data.updated_date_text;
        return {
            topic,
            cells: cellResponse.map((item, index) => {
                const cell = data.cells[index];
                if (cell.type === 'normal') {
                    const cellColumns = cell.columns || [];
                    const rawColumns = [];
                    item.noraml.columns.forEach(item => {
                        if (cellColumns.includes(item.column)) {
                            rawColumns.push(item);
                        }
                    });
                    return {
                        columns: item.noraml.columns,
                        rawColumns,
                        data: item.noraml.data,
                        typeItem: cell.type,
                        filters: cell.filters,
                        memo: cell.memo,
                        id: cell.id,
                        title: cell.title,
                        updated_date_text: cell.updated_date_text || item.updated_date_text || data.updated_date_text,
                    };
                }
                return {
                    ...item,
                    graphs: cell.graphs,
                    filters: cell.filters,
                    memo: cell.memo,
                    typeItem: cell.type,
                    id: cell.id,
                    chart: cell.chart,
                    title: cell.title,
                    updated_date_text: cell.updated_date_text || item.updated_date_text || data.updated_date_text,
                };
            }),
            updatedDateText,
        }
    };
};

export {
    getTopStatuses,
    getTopicTypes,
    getTopicCell,
    deleteTopic,
    copyTopic,
    updateTopic,
    getCategoryTopics,
    getDetailTopic,
    addTopicCell,
    removeTopicCell,
    createTopic,
    getTopic,
    updateTopicCell,
    getConfigCells,
};
